export const getSiteID = options => {
  let siteID

  // 1. 从options中获取siteID
  if (options && options.siteID) {
    siteID = Number(options.siteID) || 0
  }

  // 2. 从url中获取siteID
  if (!siteID) {
    const url = window.location.href
    const siteIDMatch = url.match(/siteID=(\d+)/)
    siteID = siteIDMatch ? Number(siteIDMatch[1]) : 0
  }

  // 3. 从localStorage中获取siteID
  if (!siteID) {
    siteID = Number(localStorage.getItem('siteID')) || 0
  }

  // // 4. 保存siteID到localStorage
  // if (siteID) {
  //   localStorage.setItem('siteID', siteID)
  // }

  // 返回
  return siteID
}
